import React, { useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";
import TipLine from "./TipLine";
import Usps from "./Usps";

export default function StepFigure() {
  const {
    car,
    currentStep,
    interiorImage
  } = useContext(CarOrderingContext)

  const imageElement = () => {
    if (typeof interiorImage?.interiorImageUrl === 'string') {
      return (
        <div className='image-container'>
          <picture data-object-fit>
            {
              typeof interiorImage?.interiorImageUrlSrcset === 'object' && interiorImage.interiorImageUrlSrcset !== null
                ? Object.entries(interiorImage.interiorImageUrlSrcset).map(entry => (
                  <source key={entry[0]} srcSet={entry[1]} media={'(max-width: ' + entry[0] + 'px)'}/>
                ))
                : null
            }
            <img src={interiorImage.interiorImageUrl} data-object-fit='true'/>
          </picture>
        </div>
      )
    }

    if (typeof car?.imageUrl === 'string') {
      return (
        <div className='image-container'>
          <img
            data-object-fit='contain'
            src={car.imageUrl}
            alt={'step-' + currentStep.id}
          />
        </div>
      )
    }

    return null
  }


  return (
    <figure data-layout={typeof interiorImage?.interiorImageUrl === 'string' ? 'full' : 'contain'}>
      <TipLine/>

      {imageElement()}

      {Array.isArray(car?.usps) && <Usps/>}
    </figure>
  )
}
